// extracted by mini-css-extract-plugin
export default {"fantasySection":"FantasySection_fantasySection__WzX2J","grid":"FantasySection_grid__Th8Gc","card":"FantasySection_card__LO+Qu","small":"FantasySection_small__WIzHB"};